var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',_vm._b({attrs:{"disabled":_vm.disabled,"variant":_vm.type,"size":"sm"},on:{"click":_vm.addNew}},'BButton',_vm.$attrs,false),[_c('plus-box-icon'),_vm._v(" Add "+_vm._s(_vm.itemName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }